<template>
  <div class="calico-card-page">
    <div class="calico-card-container">
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoFileCard
            name="filename.pdf"
            type="pdf"
            size="35kb"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoFileCard
            name="filename.png"
            type="png"
            size="35kb"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoFileCard
            name="filename.png"
            type="jpg"
            size="35kb"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoFileCard
            name="filename.png"
            type="doc"
            size="35kb"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 300px;">
          <CalicoFileCard
            name="filename.png"
            type="docx"
            size="35kb"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoFileCard from '@/components/calico/fileCard/index.vue';

export default {
  name: 'CalicoFileCardPage',
  components: {
    CalicoFileCard,
  }
};
</script>

<style lang="scss">
.calico-card-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-card-container {
    @include stack-space($space-small);
    @include inset-space($space-large);
    width: 100%;
    .calico-card-row {
      @include inline-space($space-small);
      @include inset-space($space-small);
    }
  }
}
</style>